import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';

import { Stop, ScheduledStop } from '../core/stop';
import { Route, EnhancedBuiltRoute } from '../core/route';
import { TramStop } from '../core/tram-stop';
import { RouteCollector } from './route-collector';
import { StopCollector } from './stop-collector';
import { TramCollector } from './tram-collector';
import { PanelDataExchangeService } from './panel-data-exchange.service';
import { EnhancedSegment } from '../core/segment';

@Component({
    selector: 'built-route-info-panel',
    templateUrl: './built-route-info-panel.component.html',
    styleUrls: ['./panel.scss', './built-route-info-panel.component.scss']
})
export class BuiltRouteInfoPanelComponent implements OnInit {
    private afterBuildSegmentedRouteHandler: (builtRoute: EnhancedBuiltRoute) => void;
    route: EnhancedBuiltRoute;

    segments: EnhancedSegment[];
    outerStops: Stop[];

    transferCount: number = 0;
    stopCount: number = 0;

    constructor(
        private routeCollector: RouteCollector,
        private stopCollector: StopCollector,
        private exchanger: PanelDataExchangeService) { }

    ngOnInit() {
        this.segments = [];
        this.outerStops = [];

        this.afterBuildSegmentedRouteHandler = (builtRoute: EnhancedBuiltRoute) => {
            this.route = builtRoute;
            this.segments = builtRoute.segments;
            this.outerStops = builtRoute.outerStops;
            if (this.segments && this.segments.length) { this.transferCount = this.segments.length - 1; }

            let stopCount = 0;
            this.segments.forEach(s => stopCount += s.stops.length);
            stopCount -= this.outerStops.length;
            stopCount -= this.transferCount;

            this.stopCount = stopCount;
        };
        this.routeCollector.afterBuildSegmentedRoute.on(this.afterBuildSegmentedRouteHandler);
    }

    close() {
        this.exchanger.showBuiltRouteInfoPanel(false);
    }

    hover(id: number, isSelected: boolean) {
        if (isSelected)
            this.stopCollector.highlight(id);
        else
            this.stopCollector.unhighlight(id);
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/built-route-info-panel.component.ts